<template>
  <div
    :class="[
      'up-nav-avatar-menu-options text-slate-900 text-sm font-medium my-1 rounded cursor-pointer p-2 hover:bg-slate-100 hover:font-semibold',
      {
        'font-semibold bg-secondary-50': isActive,
      },
    ]"
    @click="emit('optionClick')"
  >
    {{ optionName }}
  </div>
</template>
<script setup lang="ts">
defineProps<{
  optionName: string;
  isActive: boolean;
}>();

const emit = defineEmits<{
  optionClick: [];
}>();
</script>
